import { combineReducers } from 'redux';
import theme from './slices/themeSlice';
import auth from './slices/authSlice';
import productCategory from './slices/productCategorySlice';
import { jobCategorySlice } from './slices/jobCategorySlice';
import { userSlice } from './slices/userSlice';
import productManagement from './slices/productManagementSlice';
import jobsManagement from './slices/jobsManagementSlice';
import cache from './slices/cacheSlice';
const rootReducer = (asyncReducers) => (state, action) => {
	const combinedReducer = combineReducers({
		theme,
		auth,
		userSlice,
		jobCategorySlice,
		productCategory,
		productManagement,
		jobsManagement,
		cache,
		...asyncReducers,
	});
	return combinedReducer(state, action);
};

export default rootReducer;
